import React from "react";
import { TextField } from "material-ui";
import {
  Table,
  TableBody,
  TableFooter,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from "material-ui/Table";

import ReactDataSheet from "react-datasheet";
import "react-datasheet/lib/react-datasheet.css";

class BoxOfficeGroupSalesEntry extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { orderData, processedData } = this.props;

    const reservedSeatingSubitems = processedData.subitems.filter(
      ({ item }) => {
        return (
          item &&
          item.event &&
          item.event.venue &&
          item.event.venue.use_reserved_seating
        );
      }
    );
    const columns = [
      { name: "Email address" },
      { name: "Name (optional)" }
    ].concat(
      reservedSeatingSubitems.map(({ item }) => {
        return {
          name: `${item.event.name} seat`
        };
      })
    );

    const grid = (orderData.group_sale_data || []).concat({}).map(entry => {
      return [
        {
          __type: "email",
          value: entry.email || ""
        },
        {
          __type: "name",
          value: entry.name || ""
        }
      ].concat(
        reservedSeatingSubitems.map(({ item }) => {
          return { __type: "seat", value: (entry.seats || {})[item.id] || "" };
        })
      );
    });

    return (
      <div>
        <div style={{ maxWidth: 500, margin: "1em 0 0.5em" }}>
          <div>
            <strong>Group sales</strong> allows you to repeat the same order
            multiple times. The above order will be repeated once for each
            individual entered below. The entered payment method will be used
            for each order.
          </div>
          <div style={{ marginTop: 5 }}>
            <i>Tip: Copy and paste from a spreadsheet for large orders!</i>
          </div>
        </div>
        <div style={{ maxWidth: 500, marginBottom: "0.75em" }}>
          <ReactDataSheet
            data={grid}
            dataRenderer={cell => cell.value}
            valueRenderer={cell =>
              cell.__type && !cell.value ? (
                <span style={{ opacity: 0.2 }}>
                  {cell.__type === "email"
                    ? "customer@example.com"
                    : cell.__type === "name"
                    ? "Jane Doe"
                    : "A-1"}
                </span>
              ) : (
                cell.value
              )
            }
            sheetRenderer={props => (
              <table className={props.className}>
                <thead>
                  <tr>
                    {columns.map(col => (
                      <th>{col.name}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>{props.children}</tbody>
              </table>
            )}
            onCellsChanged={(changes, additions) => {
              const newGrid = grid.map(row => [...row]);
              changes
                .concat(additions || [])
                .forEach(({ cell, row, col, value }) => {
                  while (!newGrid[row]) {
                    newGrid.push([]);
                  }
                  while (!newGrid[row][col]) {
                    newGrid[row].push({});
                  }
                  newGrid[row][col] = { ...newGrid[row][col], value };
                });
              this.props.updateCurrentOrder({
                group_sale_data: newGrid
                  .filter(r => r.some(x => !!x.value))
                  .map(row => {
                    let data = {
                      email: row[0].value,
                      name: row[1].value,
                      seats: {}
                    };
                    reservedSeatingSubitems.forEach(({ item }, i) => {
                      data.seats[item.id] = row[2 + i].value;
                    });
                    return data;
                  })
              });
            }}
          />
        </div>
        <style>{`
          .data-grid-container .data-grid .cell.selected {
            box-shadow: none !important;
          }
          .data-grid-container .data-grid .cell.updated {
            background: none !important;
          }
          .data-grid-container {
            line-height: 1;
            font-family: Arial !important;
          }
          .data-grid-container .data-grid .cell {
            padding: 5px;
          }
          .data-grid-container input.data-editor {
            outline: 0px !important;
            border: 0px !important;
            width: calc(100% - 2px) !important;
            font-size: 13px !important;
            height: 15px !important;
            margin-bottom: -2px !important;
          }
          .data-grid-container th {
            padding: 10px 2px 5px !important;
          }
        `}</style>
      </div>
    );
  }
}

export default BoxOfficeGroupSalesEntry;



// WEBPACK FOOTER //
// ./src/app/components/partials/box-office/box-office-group-sales-entry.jsx